module.exports = __webpack_public_path__ + "img/ai-chat-active.49a5141b.svg";